export default {
  LIST(state, data) {
    state.letters = data
  },
  GET(state, data) {
    state.letter = data
  },
  TABLE_ONE(state, data) {
    state.table_one = data
  },
  TABLE_TWO(state, data) {
    state.table_two = data
  },
  PERIODS(state, data) {
    state.periods = data
  },
  ORGANIZATIONS(state, data) {
    state.organizations = data
  },
  UPDATE(state, value) {
    state.letter = { ...value }
  },
  FRESH(state, letter_type = null) {
    state.letter = {
      id: null,
      code: '',
      short_info: '',
      letter_status: 100,
      letter_type,
      period_id: null,
      from_org: null,
      to_org: null,
    }
  },
  HISTORY_LETTER(state, data) {
    state.history_letter = data
  },
  FRESH_REJECT(state) {
    state.reject = {
      reject_info: '',
    }
  },
  FRESH_HISTORY(state, letter_type = null) {
    state.history_letter = {
      id: null,
      code: '',
      short_info: '',
      letter_status: 100,
      letter_type,
      period: null,
      from_org: null,
      to_org: null,
    }
  },
}
